import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { applicationActions } from '../actions';
import { ApplicationResource } from '../services';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../services";
import * as i3 from "@ngrx/store";
/**
 * The application effects imported in {@link ApplicationApiModule }
 *
 */
export class ApplicationEffects {
    constructor(applicationActions$, api, store) {
        this.applicationActions$ = applicationActions$;
        this.api = api;
        this.store = store;
        /**
         * Loads all the availabe applications only when a user is logged in and triggers a LoadSuccess action.
         *
         * @returns { Observable<Action> } Observable with LoadSuccess action when all applications are retrieved
         */
        this.load$ = createEffect(() => this.applicationActions$.pipe(ofType(applicationActions.LOAD), switchMap(() => this.api.query().pipe(map((apps) => new applicationActions.LoadSuccess(apps)), catchError((error) => [
            new applicationActions.LoadFailed({
                error: error,
                message: 'Unable to load applications'
            })
        ])))));
        /**
         * Loads specific application only when a user is logged in and triggers a LoadByIdSuccess action.
         *
         * @returns { Observable<Action> } Observable with LoadByIdSuccess action when all applications are retrieved
         */
        this.loadById$ = createEffect(() => this.applicationActions$.pipe(ofType(applicationActions.LOAD_BY_ID), switchMap((action) => this.api.queryById(action.payload).pipe(map((apps) => new applicationActions.LoadByIdSuccess(apps)), catchError((error) => [
            new applicationActions.LoadByIdFailed({
                error: error,
                message: 'Unable to load application'
            })
        ])))));
        /**
         * Updates the application and triggers a UpdateSuccess action.
         *
         * @returns { Observable<Action> } Observable with UpdateSuccess action with the updated application
         */
        this.update$ = createEffect(() => this.applicationActions$.pipe(ofType(applicationActions.UPDATE), map((action) => action.payload), withLatestFrom(this.store.pipe(select(authSelectors.getUserId))), switchMap(([application, userId]) => {
            application.lastModifiedBy = userId;
            return this.api.update(application).pipe(map((app) => new applicationActions.UpdateSuccess(app)), catchError((error) => [
                new applicationActions.UpdateFailed({
                    error: error,
                    message: 'Unable to update application'
                })
            ]));
        })));
        /**
         * Create new application and CreateSuccess action.
         *
         * @returns { Observable<Action> } Observable with CreateSuccess action with the updated application
         */
        this.create$ = createEffect(() => this.applicationActions$.pipe(ofType(applicationActions.CREATE), map((action) => action.payload), withLatestFrom(this.store.pipe(select(authSelectors.getUserId))), switchMap(([app, userId]) => {
            app.lastModifiedBy = userId;
            app.createdBy = userId;
            return this.api.create(app).pipe(map((newApp) => new applicationActions.CreateSuccess(newApp)), catchError((error) => [
                new applicationActions.CreateFailed({
                    error: error,
                    message: 'Unable to create application'
                })
            ]));
        })));
        /**
         * Delete application and triggers DeleteSuccess action.
         *
         * @returns { Observable<Action> } Observable with DeleteSuccess action with the deleted app id
         */
        this.delete$ = createEffect(() => this.applicationActions$.pipe(ofType(applicationActions.DELETE), map((action) => action.payload), switchMap((appId) => this.api.delete(appId).pipe(map(() => new applicationActions.DeleteSuccess(appId)), catchError((error) => [
            new applicationActions.DeleteFailed({
                error: error,
                message: 'Unable to delete application'
            })
        ])))));
    }
    static { this.ɵfac = function ApplicationEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ApplicationEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.ApplicationResource), i0.ɵɵinject(i3.Store)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApplicationEffects, factory: ApplicationEffects.ɵfac }); }
}
//# sourceMappingURL=application.effects.js.map